/**
 * CSSカスタムプロパティ: PageLayoutFrameの内部コンテンツを
 * 横方向に同期スクロールさせるための変数名。
 */
export const PAGE_LAYOUT_FRAME_SCROLL_CSS_VAR = '--page-layout-frame-scroll-x';
